import React, { ChangeEvent, FC, useState } from 'react';
import Ticket from '../../../../../../interfaces/api/Ticket';
import AppointmentTable from './components/AppointmentTable';
import { SubTab, SubTabs } from '../../../../../../components/Tabs';
import SwipeableViews from 'react-swipeable-views';
import NoteTable from './components/NoteTable';
import ReminderTable from './components/ReminderTable';
import TaskTable from './components/TaskTable';

interface Props {
  style?: Object;
  hidden?: boolean;
  ticket: Ticket;
}

interface Route {
  id: string;
  label: string;
  component: any;
}

const routes: Array<Route> = [
  {
    id: 'appointments',
    label: 'Rendez-vous',
    component: AppointmentTable,
  },
  {
    id: 'notes',
    label: 'Notes',
    component: NoteTable,
  },
  {
    id: 'reminders',
    label: 'Rappels',
    component: ReminderTable,
  },
  {
    id: 'tasks',
    label: 'Tâches',
    component: TaskTable,
  },
];

const PlanningCard: FC<Props> = ({ ticket, ...props }) => {
  const [currentPage, setCurrentPage] = useState(0);

  const handleTabChange = (event: ChangeEvent<{}>, newValue: number) => {
    handlePageChange(newValue);
  };

  const handlePageChange = (index: number) => {
    setCurrentPage(index);
  };

  return (
    <div {...props}>
      <SubTabs
        indicatorColor='primary'
        textColor='primary'
        variant='scrollable'
        scrollButtons='auto'
        value={currentPage}
        onChange={handleTabChange}
      >
        {routes.map((route, key) => (
          <SubTab key={key} label={route.label} value={key} />
        ))}
      </SubTabs>

      <SwipeableViews index={currentPage} onChangeIndex={handlePageChange}>
        {routes.map((route, key) => {
          const Component = route.component;
          const routeProps: any = {
            ticketId: ticket.id,
          };

          switch (route.id) {
            case 'notes':
              routeProps.notesIds = ticket.notesIds;
              break;
            case 'reminders':
              routeProps.remindersIds = ticket.remindersIds;
              break;
            case 'appointments':
              routeProps.appointmentsIds = ticket.appointmentsIds;
              break;
            case 'tasks':
              routeProps.tasksIds = ticket.tasksIds;
              break;
          }

          return <Component key={key} {...routeProps} hidden={key !== currentPage} style={{ padding: 16 }} />;
        })}
      </SwipeableViews>
    </div>
  );
};

export default PlanningCard;
